import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
        computed, 
        ComputedRef
    } from 'vue'
    import {
        IFeedbackStyling
    } from '@/interfaces'
    import status from '@/store/status'
    import score from '@/store/score'
    import GenericButton from './GenericButton.vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    answer: null,
    wasCorrect: { type: Boolean },
    wasAnswered: { type: Boolean },
    styling: null
  },
  emits: ["getQuestion", "playAgain"],
  setup(__props: any, { emit }: { emit: ({
        (event: 'getQuestion'): void,
        (event: 'playAgain'): void
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        answer: number
        wasCorrect: boolean
        wasAnswered: boolean,
        styling: IFeedbackStyling
    }

    

    

    const feedback: ComputedRef<string> = computed(() => {
        if (status.hasWon || status.hasLost) {
            const winMessage: string = `You got ${score.value} points and won!`
            const loseMessage: string = 'You got 3 strikes and lost!'
            const gameOverMessage: string = status.hasWon ? winMessage : loseMessage

            return gameOverMessage
        } else {
            if (!props.wasAnswered) {
                const strikeMessage: string = 'You did not answer the question. YOU GOT A STRIKE!'

                return strikeMessage
            } else {
                const answerMessage: string = `The answer was ${props.answer}. You were ${props.wasCorrect ? 'CORRECT' : 'INCORRECT'}!`

                return answerMessage
            }
        }
    })

    const buttonText: ComputedRef<string> = computed(() => {
        let text: string = ''

        if (status.value) {
            text = 'Next'
        } else {
            text = 'Play Again'
        }

        return text
    })

    function handleClick(): void {
        if (status.value) {
            emit('getQuestion')
        } else {
            emit('playAgain')
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", null, [
    _createElementVNode("p", {
      class: _normalizeClass(props.styling)
    }, _toDisplayString(_unref(feedback)), 3),
    _createVNode(GenericButton, {
      text: _unref(buttonText),
      onClick: handleClick
    }, null, 8, ["text"])
  ]))
}
}

})